<template>
  <v-card class="mx-auto mt-12 border-styles-top login elevation-8" max-width="550" flat>
    <v-toolbar color="primary" dark extended flat class="border-styles">
      <v-layout justify-center>
        <v-toolbar-title class="mt-6">Customer Login</v-toolbar-title>
      </v-layout>
    </v-toolbar>
      <v-card-text class="mt-5">
        <v-layout column>
          <v-form ref="loginForm" autocomplete="off">
            <v-text-field
              v-model="model.username"
              class="mt-3"
              outlined
              append-icon="mdi-account"
              :rules="$_requiredValidation"
              id="username_field"
              :label="$t('message.login.userName')"
              type="text"
            ></v-text-field>
            <v-text-field
              v-model="model.password"
              outlined
              id="password_field"
              :rules="$_requiredValidation"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              @keyup.enter="loginHandler"
              :label="$t('message.login.password')"
              :type="showPassword ? 'text' : 'password'"
              @click:append="showPassword = !showPassword"
            ></v-text-field>
            <v-select
              append-icon="mdi-earth"
              id="lang_select"
              outlined
              :label="$t('message.login.language')"
              :items="language"
              v-model="defaultLang"
              item-text="title"
              item-value="value"
            ></v-select>
            <v-layout justify-center class="mt-5">
              <v-btn
                color="primary"
                class="mr-4"
                :loading="loading"
                @click="loginHandler"
              >{{ $t('message.layout.login') }}</v-btn>
            </v-layout>
          </v-form>
        </v-layout>
      </v-card-text>
    </v-card>
</template>
<script>
export default {
  data () {
    return {
      loading: false,
      model: {
        username: '',
        password: ''
      },
      defaultLang: this.$i18n.locale || 'no',
      showPassword: false
    }
  },
  computed: {
    language () {
      return [
        { title: this.$t('message.common.english'), value: 'en' },
        { title: this.$t('message.common.norwegian'), value: 'no' }
      ]
    }
  },
  watch: {
    defaultLang () {
      this.$i18n.locale = this.defaultLang
    }
  },
  methods: {
    loginHandler () {
      if (this.$refs.loginForm.validate()) {
        /* this.loading = true
        //make http request and get response then dispatch
        this.$store.dispatch('login', model)
          .then(() => {
            this.$router.push({ path: this.$route.query.redirect || 'dashboard' })
          }).finally(() => {
            this.loading = false
          }) */
      } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: 'message.common.validationIssue' })
    }
  }
}
</script>
<style scoped>
.border-styles {
  border-top-right-radius: 40px !important;
  border-bottom-left-radius: 40px !important;
}
.login .v-sheet--offset {
  top: -30px;
  position: relative;
}
.v-toolbar {
  height: 80px !important;
}
</style>
